import { useState } from 'react';
import styles from './MessageModal.module.css';
import { IcoStudio, IcoCalSm, IcoClock } from './DashboardIcons';

const MESSAGES = [
  { id: 0, type: '캐스팅 제안', isNew: true, title: '넷플릭스 오리지널 드라마', company: '스튜디오드래곤', date: '2026. 01. 01', time: '오전 10:30', preview: '안녕하세요. 귀하의 프로필을 보고 연락드립니다. 저희 드라마 주연 배역에 관심이 있으신가요?...' },
  { id: 1, type: '콜백', isNew: false, title: '독립영화 장편', company: '인디필름', date: '2026. 01. 01', time: '오전 10:30', preview: '공고 참여 감사드립니다. 2차 콜백 일정을 확인해주세요.' },
];

function MessageModal({ onClose }) {
  const [expanded, setExpanded] = useState(1);

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div className={styles.modalHeader}>
          <div className={styles.modalHeaderLeft}>
            <span className={styles.modalTitle}>캐스팅 제의 메시지</span>
            <div className={styles.newMessageBadge}>
              <span className={styles.newMessageBadgeText}>2개의 새 메시지</span>
            </div>
          </div>
          <button className={styles.closeButton} onClick={onClose}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M2 2l16 16M18 2L2 18" stroke="#A2A2A2" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        {/* Message list */}
        <div className={styles.messageList}>
          {MESSAGES.map((msg) => (
            <div key={msg.id}>
              {/* Card header */}
              <div
                className={`${styles.cardHeader} ${expanded === msg.id ? styles.cardHeaderExpanded : styles.cardHeaderCollapsed}`}
                onClick={() => setExpanded(expanded === msg.id ? -1 : msg.id)}
              >
                <div className={styles.cardTagRow}>
                  <div className={styles.typeTag}>
                    <span className={styles.typeTagText}>{msg.type}</span>
                  </div>
                  {msg.isNew && (
                    <div className={styles.newTag}>
                      <span className={styles.newTagText}>NEW</span>
                    </div>
                  )}
                </div>

                <div className={styles.cardMeta}>
                  <div className={styles.cardTitle}>{msg.title}</div>
                  <div className={styles.cardMetaRow}>
                    <div className={styles.metaItem}>
                      <IcoStudio /><span className={styles.metaText}>{msg.company}</span>
                    </div>
                    <div className={styles.metaItemMiddle}>
                      <IcoCalSm /><span className={styles.metaText}>{msg.date}</span>
                    </div>
                    <div className={styles.metaItemLast}>
                      <IcoClock /><span className={styles.metaText}>{msg.time}</span>
                    </div>
                  </div>
                </div>

                <div className={styles.cardPreview}>{msg.preview}</div>
              </div>

              {/* Expanded panel */}
              {expanded === msg.id && (
                <div className={styles.expandedPanel}>
                  <div className={styles.expandedContent}>
                    <div className={styles.expandedBody}>{msg.preview.replace('...', '')}</div>
                    <div className={styles.actionRow}>
                      <button className={styles.replyButton}>답장하기</button>
                      <button className={styles.viewProjectButton}>프로젝트 보기</button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}

export default MessageModal;
